import { TrainingAPI } from "../../api/TrainingAPI";

const trainingAPI = new TrainingAPI();

export const DRILLS_SET_LOADING = "[DRILLS]_SET_LOADING";
export const DRILLS_SET_FILTER = "[DRILLS]_SET_FILTER";
export const DRILLS_SET_DRILLS = "[DRILLS]_SET_DRILLS";
export const DRILLS_SET_DATES_PER_DRILL = "[DRILLS]_SET_DATES_PER_DRILL";
export const DRILLS_SET_BREAKDOWN_DATA = "[DRILLS]_SET_DATA";
export const DRILLS_SET_COMPARE_DATA = "[DRILLS]_SET_COMPARE_DATA";

export const setDrillsLoading = (val) => ({
  type: DRILLS_SET_LOADING,
  payload: val,
});

export const setDrills = (drills) => ({
  type: DRILLS_SET_DRILLS,
  payload: drills,
});

export const setDrillsDates = (dates) => ({
  type: DRILLS_SET_DATES_PER_DRILL,
  payload: dates,
});

export const setDrillsBreakdownData = (data) => ({
  type: DRILLS_SET_BREAKDOWN_DATA,
  payload: data,
});

export const setDrillsCompareData = (data) => ({
  type: DRILLS_SET_COMPARE_DATA,
  payload: data,
});

export const setDrillsFilterDrill = (drill) => ({
  type: DRILLS_SET_FILTER,
  payload: { drill },
});

export const setDrillsFilterDate = (date) => ({
  type: DRILLS_SET_FILTER,
  payload: { date },
});

export const setDrillsFilterPosition = (position) => ({
  type: DRILLS_SET_FILTER,
  payload: { position },
});

export const changeDrillSelection = (drill) => {
  return async (dispatch) => {
    try {
      const data = await trainingAPI.getDrillDates(drill);
      await dispatch(setDrillsFilterDrill(drill));
      await dispatch(setDrillsDates(data));
      await dispatch(setDrillsFilterDate(undefined));
      await dispatch(setDrillsBreakdownData([]));
    } catch (e) {
      console.error(e);
    }
  };
};

export const changeDateSelection = (date) => {
  return async (dispatch) => {
    await dispatch(setDrillsFilterDate(date));
    await dispatch(setDrillsFilterPosition(undefined));
    await dispatch(getDrillsBreakdownData());
  };
};

export const changePositionSelection = (position) => {
  return async (dispatch) => {
    await dispatch(setDrillsFilterPosition(position));
    await dispatch(getDrillsBreakdownData());
  };
};

export const getDrillsBreakdownData = () => {
  return async (dispatch, getState) => {
    dispatch(setDrillsLoading(true));
    try {
      const {
        filter: { drill, date, position },
      } = getState().drills;
      const data = await trainingAPI.getDrillBreakdownIndividual(
        drill,
        date,
        position
      );
      dispatch(setDrillsBreakdownData(data));
    } catch (e) {
      console.error(e);
    }
    dispatch(setDrillsLoading(false));
  };
};

export const getDrills = () => {
  return async (dispatch) => {
    try {
      const drills = await trainingAPI.getDrills();
      dispatch(setDrills(drills));
    } catch (e) {
      console.error(e);
    }
  };
};

export const getDrillsCompareData = () => {
  return async (dispatch) => {
    try {
      const data = await trainingAPI.getDrillCompare();
      dispatch(setDrillsCompareData(data));
    } catch (e) {
      console.error(e);
    }
  };
};
